<template>
    <div v-if="operationtype === 'category'" class="kanbai absolute w-full h-full">
        <div class="flex items-center justify-center w-full h-full bg-theme-white bg-opacity-50 ">
            <p class="text-txt-red border-2 border-bd-red bg-theme-white bg-opacity-75 rounded text-xl px-4 py-2">完売</p>
        </div>
    </div>   
    <div v-if="operationtype === 'group'" class="kanbai absolute top-5">
        <div class="flex items-center justify-center w-full h-full bg-theme-white bg-opacity-50 ">
            <p class="text-txt-red border-2 border-bd-red bg-theme-white bg-opacity-75 rounded text-sm px-4">完売</p>
        </div>
    </div> 
    <div v-if="operationtype === 'product'" class="kanbai absolute w-full h-full">
        <div class="flex items-center justify-center w-full h-full bg-theme-white bg-opacity-50 ">
            <p class="text-txt-red border-2 border-bd-red bg-theme-white bg-opacity-75 rounded text-xl px-4 py-2">完売</p>
        </div>
    </div> 
</template>
<script>
    import { useRoute } from 'vue-router'
    import { ref } from 'vue';
    
    export default {
        setup() {
            const route = useRoute()
            const operationtype = ref(route.query.operationtype)
            // console.log(operationtype.value)
            
            
            return {
                operationtype
            }
        }
    }
</script>